export default {
    title: 'Gacha sao',
    labels: {
        inventory: 'Avatar đang có',
        machine: 'Máy Gacha sao',
    },
    messages: {
        insufficientStars: 'Không đủ sao. 😢',
        ctaText: 'Hãy nhấn vào tôi để đưa vào kho lưu trữ!',
    },
};
